<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col class="text-h5 gray--text">Detalhes da cirurgia</v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-card>
            <v-container fluid>
              <v-row>
                <v-col>
                  <v-row dense>
                    <v-col class="font-weight-bold"> Cirurgia </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ surgeryIndication.surgeryType.name }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col v-if="surgeryIndication.surgeryTypeTechnique">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Técnica </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ surgeryIndication.surgeryTypeTechnique.name }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col v-if="surgeryIndication.site">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Local </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ surgeryIndication.site }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col v-if="surgeryIndication.anesthesia">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Anestesia </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ surgeryIndication.anesthesia }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col>
                  <v-row dense>
                    <v-col class="font-weight-bold"> Materiais </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ materials }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="4">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Observação </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ surgeryIndication.observation }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SurgeryDetail",
  props: {
    surgery: Object,
  },
  computed: {
    surgeryIndication() {
      return this.surgery.surgeryIndication;
    },
    materials() {
      return this.lodash.join(
        this.surgeryIndication.materials.map((e) => e.name),
        ", "
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
